module.exports = __webpack_public_path__ + "static/media/status_bar_light.2ab20023.png";